<template>
  <div class="notification_detail">
    <van-nav-bar
      title="系统消息"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />
    <van-list
      v-model="loading"
      finished-text="没有更多了"
      :finished="finished"
      :immediate-check="true"
      @load="onLoad"
    >
      <notify-detail-panel
        v-for="(item, index) in list"
        :key="index"
        :type="type"
        :notify="item"
      />
    </van-list>
  </div>
</template>

<script>
import { List, NavBar } from 'vant'
import NotifyDetailPanel from './components/NotifyDetailPanel'
import { notifyList } from '@/api/notify'

export default {
  name: 'NotificationDetail',
  components: {
    [List.name]: List,
    [NavBar.name]: NavBar,
    NotifyDetailPanel
  },
  data () {
    return {
      type: 1,
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        page: 0,
        size: 8
      }
    }
  },
  created () {
    const type = parseInt(this.$route.query.type)
    this.type = isNaN(type) ? 1 : type
    this.initQuery()
  },
  methods: {
    initQuery () {
      if (this.type === 1) {
        this.listQuery.notify_type = 3
        this.listQuery.is_system = 1
      } else if (this.type === 2) {
        this.listQuery.notify_type = 2
      }
    },
    async getList () {
      this.loading = true
      const response = await notifyList(this.listQuery)
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList()
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
